import React from 'react'
import { NavLink, Switch, Route } from 'react-router-dom'
import MineID from 'app/mine/id'
import MineOrder from 'app/mine/order'
import OrderDetail from 'app/mine/order/order-detail'
import './index.less'

const list = [
  {
    label: '订单中心',
    value: '1',
    path: '/mine/order',
  },
  {
    label: '账号信息',
    value: '2',
    path: '/mine/id',
  },
]

export default function Mine() {
  return (
    <div className="mine">
      <div className="mine-tabs">
        {list.map(item => (
          <NavLink
            to={item.path}
            key={item.value}
            className={isActive => {
              return isActive
                ? 'mine-tabs-item mine-tabs-item-on'
                : 'mine-tabs-item'
            }}
          >
            {item.label}
          </NavLink>
        ))}
      </div>
      <div className="mine-cont">
        <Switch>
          <Route path="/mine/id">
            <MineID />
          </Route>
          <Route path="/mine/order">
            <MineOrder />
          </Route>
          <Route path="/mine/order-detail/:orderNo">
            <OrderDetail />
          </Route>
        </Switch>
      </div>
    </div>
  )
}
